<template>
  <v-dialog :value="value" max-width="1280" width="92vw" @input="onDialogInput">
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="text-subtitle-1 font-weight-bold">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <a class="pdf-viewer__open-link mr-2" :href="src" target="_blank" rel="noopener">
          Abrir en pestaña nueva
        </a>
        <v-btn icon aria-label="Cerrar" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <iframe :src="viewerSrc" title="Visor de documento" style="width: 100%; height: 85vh; border: 0"></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
// Visor PDF nativo del navegador embebido en un modal; `src` puede ser un blob URL
// (archivo aún no guardado) o la URL pública del CDN.

// Parámetros de apertura del visor PDF (Chrome/Edge/Firefox): ajusta la página al ancho del
// modal y oculta el panel de miniaturas, que con el modal angosto dejaba el documento al ~50 %.
const VIEWER_PARAMS = 'view=FitH&navpanes=0';

export default {
  name: 'PdfViewerDialog',
  props: {
    value: { type: Boolean, default: false },
    src: { type: String, default: '' },
    title: { type: String, default: 'Documento' }
  },
  computed: {
    viewerSrc() {
      if (!this.src || this.src.includes('#')) return this.src;
      return `${this.src}#${VIEWER_PARAMS}`;
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    onDialogInput(open) {
      if (!open) this.close();
    }
  }
};
</script>

<style scoped>
.pdf-viewer__open-link {
  font-size: 14px;
}
</style>
